import { useQuery } from '@tanstack/react-query'
import { api } from '../lib/api'

export function useDevices() {
  return useQuery({
    queryKey: ['devices'],
    queryFn: () => api.listDevices().then((r) => r.devices),
    refetchInterval: 30_000,
  })
}
